import { Link } from "react-router-dom";
import { RiLinkM } from "react-icons/ri";
import light from "../../../assets/images/light.svg";
import faceReels from "../../../assets/images/face-reels.svg";
import Footer from "../../../components/reuseables/Footer"

function WebLayout({ data }) {
  return (
    <div className="bg-bg-white">
      <div className="container mx-auto py-[64px] md:py-[100px] md:w-full w-11/12">
        {/* Header */}
        <div className="flex justify-center gap-x-2 text-black text-[18px] md:text-[22px] leading-[28px] font-semibold ">
          <Link
            to="/our-works"
            className="text-[18px] md:text-[22px] font-medium text-black/70"
          >
            Our Works
          </Link>{" "}
          / {data.title}
        </div>

        {/* Hero Section */}
        <div className="px-[16px] md:px-0 mt-[48px] flex flex-col items-center justify-center">
          <h1 className="font-semibold md:font-bold text-[28px] md:text-[48px] leading-[56px] text-center">
            {data.title}
          </h1>
          <p className="mt-2 font-normal md:font-medium md:text-[22px] leading-[28px] md:leading-[36px] text-center text-black/70 md:w-[70%] w-full">
            {data.description}
          </p>
          {data.link && (
            <>
             
              <a
                href={data.link}
                target="_blank"
                rel='noreferrer'
                className="flex items-center p-4 bg-black text-white border border-black rounded-full mt-12"
              >
                {" "}
                <span className="pr-2">{data.sub === "mobile application" ? "Visit PlayStore" : "Visit"} {data.slug.toLowerCase()}</span>
                <RiLinkM color="#fff" className="w-6 h-6" />
              </a>
            </>
          )}
          <div className=" md:mt-[48px] mt-[24px] w-full md:w-[1240px] md:h-[591px] h-[224px] ">
            <img
              src={data.heroBg}
              alt={data.title}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      {/* Project Scope Web*/}
      {data.projectImg_web && (
        <div className="bg-bg-black py-[64px] md:py-[100px]">
          <div className="container mx-auto md:w-full w-11/12">
            <div className="bg-white px-3 py-[26px] md:p-[40px] rounded">
              <h2 className="font-semibold md:font-bold text-[28px] md:text-[48px] leading-[36px] md:leading-[56px]">
                Project scope
              </h2>
              <p className="w-full max-w-[977px] text-sm md:text-[18px] leading-[22px] md:leading-[28px] mt-3">
                {data.project_Scope}
              </p>

              <div className="hidden mt-8 md:mt-[48px] md:grid md:grid-cols-2 gap-x-[24px]">
                <img
                  src={data.projectImg_web[0]}
                  alt={data.title}
                  className="w-full"
                />
                <img
                  src={data.projectImg_web[1]}
                  alt={data.title}
                  className="w-full"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Project Scope Branding*/}
      {data.projectImg_brand && (
        <div className="bg-bg-black py-[64px] md:py-[100px]">
          <div className="container mx-auto px-[16px] md:px-0">
            <div className="bg-white px-3 py-[26px] md:p-[40px] rounded">
              <h2 className="font-semibold md:font-bold text-[28px] md:text-[48px] leading-[36px] md:leading-[56px]">
                Project scope
              </h2>
              <p className=" w-full max-w-[677px] text-sm md:text-[18px] leading-[22px] md:leading-[28px] mt-3">
                {data.project_Scope}
              </p>

              <div className="mt-8 md:mt-[48px] flex justify-between gap-x-[24px] rounded h-[524px] overflow-hidden">
                <iframe
                  width="100%"
                  height="100%"
                  src={data.projectImg_brand}
                  title="How React Hooks work? Understand its internals."
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Element Spotlight */}
      {data.spotlight_Img && (
        <div className="py-[64px] md:py-[100px] bg-bg-white">
          <div className="container mx-auto px-[16px] md:px-0">
            <div className="flex items-center justify-center">
              <h2 className="font-semibold md:font-bold text-[28px] md:text-[48px] leading-[36px] md:leading-[48px] pr-4">
                Element Spotlight
              </h2>
              <img
                src={light}
                alt="Light Bulb"
                className="w-[44px] h-[44px] md:w-[69px] md:h-[69px]"
              />
            </div>

            <div className="mt-8 md:mt-[48px] w-full grid grid-cols-2 md:gap-8 gap-4">
              <div className="w-full">
                <img
                  src={data.spotlight_Img[0]}
                  alt="Branding"
                  className="h-full w-full"
                />
              </div>
              <div className="flex flex-col md:gap-y-6 gap-y-4 w-full items-center justify-between">
                <div className="h-full w-full">
                  <img
                    src={data.spotlight_Img[1]}
                    alt="Branding"
                    className="h-full w-full"
                  />
                </div>
                <div className="w-full h-full">
                  <img
                    src={data.spotlight_Img[2]}
                    alt="Branding"
                    className="h-full w-full"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Identity Reels */}
      {data.reels && (
        <div className="bg-bg-black text-white py-[64px] md:py-[100px]">
          <div className="container mx-auto px-[16px] md:px-0">
            <div className="flex items-center justify-center">
              <h2 className="font-semibold md:font-bold text-[28px] md:text-[48px] leading-[36px] md:leading-[48px] pr-4">
                Identity Reels
              </h2>
              <img
                src={faceReels}
                alt="Face Emoji"
                color="#000"
                className="w-[44px] h-[44px] md:w-[69px] md:h-[69px]"
              />
            </div>

            <div className="grid grid-cols-2 item-center justify-items-center gap-4 md:gap-[40px] mt-8 md:mt-[48px]">
              {data.reels.map((item) => (
                <img
                  key={item.id}
                  src={item}
                  alt="Identity Reels"
                  className="w-full"
                />
              ))}
              <div className=" w-full col-span-2 rounded md:h-[524px] overflow-hidden">
                <iframe
                  width="100%"
                  height="100%"
                  src={data.projectImg_brand}
                  title="How React Hooks work? Understand its internals."
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Section HighLights */}
      {data.highlight && (
        <div className="py-[64px] md:py-[100px] bg-bg-white">
          <div className="container mx-auto px-[16px] md:px-0">
            <div className="flex items-center justify-center">
              <h2 className="font-semibold md:font-bold text-[28px] md:text-[48px] leading-[36px] md:leading-[48px] pr-4">
                Section Highlights
              </h2>
              <img
                src={light}
                alt="Light Bulb"
                className="w-[44px] h-[44px] md:w-[69px] md:h-[69px]"
              />
            </div>

            <div className="mt-8 md:mt-[48px] grid grid-cols-2 justify-items-center gap-4 md:gap-[40px]">
              {data.highlight.map((item) => (
                <div key={item.id} className="w-full md:h-[453px] h-[150px]">
                  <img
                    src={item}
                    alt="Identity Reels"
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Tech Stack */}
      {data.tech_stack && (
        <div className="py-[32px] md:py-[50px] px-[16px] md:px-0">
          <div className="flex flex-col item-center">
            <h3 className="font-medium md:font-bold text-[28px] md:text-[48px] leading-[28px] md:leading-[48px] text-center">
              This {data.sub} was created using
            </h3>
            <ul className="flex flex-wrap justify-center gap-x-2 gap-y-4 md:gap-[15px] mt-8 md:mt-[48px]">
              {data.tech_stack.map((item) => (
                <li className="px-4 py-2 md:px-[26px] md:py-[18px] md:text-lg md:leading-[24px] text-center font-medium md:font-semibold border border-black/50 rounded-full">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
      <Footer/>
    </div>
  );
}

export default WebLayout;
